import { Box, Checkbox, FormControlLabel, FormHelperText, Grid2, InputLabel, MenuItem, Select, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material"
import * as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { Controller, useForm } from "react-hook-form"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { useContext, useEffect, useState } from "react"
import { useUpdateRecruiterMutation, useViewRecruiterDetailsByIdForAdminQuery, useViewRecruiterDetailsByIdQuery } from "../../redux/Profile/profile.api"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useLocation, useNavigate } from "react-router-dom";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import dayjs from 'dayjs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import FileUpload from "../Profile/FileUpload"
import Dropdown from "../../reusable_components/components/Dropdown"
import { useSelector } from "react-redux"
import { current } from "@reduxjs/toolkit"

const SUPPORTED_FORMATS = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

const RecruiterProfileEdit = () => {

  const [isCost, setIsCost] = useState(false)
  const { recruiterIdAdmin, externalRecruiter } = useSelector((state) => state?.common);

  const step1ValidationSchema = (externalRecruiter) =>
    Yup.object().shape({
      name: Yup.string().required('Name is Required'),
      address: Yup.string().required('Address is Required'),
      state: Yup.string().required('State is Required'),
      contactNumber: Yup.string().required('Contact Number is Required'),
      email: Yup.string().required('Email is Required'),
      city: Yup.string().required('City is Required'),
      pincode: Yup.string().required('Pincode is Required'),
      gender: Yup.string().required('Gender is Required'),
      dateOfBirth: Yup
        .date()
        .nullable()
        .required("Date of Birth is Required")
        .max(new Date(), "Date of Birth cannot be in the future"),
      isExternalRecruiter: Yup.string().required('Business Associate is Required'),
      alternateNumber: Yup.string()
        .nullable()
        .notRequired()
        // .test('valid-number', 'Alternate number must be 10 digits', function (value) {
        //   if (!value) return true; // skip validation if empty
        //   return value.length === 10 && /^[0-9]+$/.test(value);
        // })
        .test('different-number', 'Alternate number must be different from contact number', function (value) {
          if (!value) return true; // skip validation if empty
          const contactNumber = this.resolve(Yup.ref('contactNumber'));
          return value !== contactNumber;
        }),
      alternateEmail: Yup.string()
        .nullable()
        .notOneOf([Yup.ref('email')], "Alternate Email should not be same as email")
        .transform(value => value === '' ? null : value),
    });

  // const step2ValidationSchema = Yup.object().shape({
  // rewardType: Yup.string().nullable(),
  // rewardsRs: Yup.string().nullable(),
  //   // .nullable()
  //   // .test('is-required-if-1', 'Reward amount is Required', function (value) {
  //   //   return this.parent.rewardType !== '1' || !!value;
  //   // }),
  // rewardsPercent: Yup.string().nullable()
  //   // .nullable()
  //   // .test('is-required-if-2', 'Reward percentage is Required', function (value) {
  //   //   return this.parent.rewardType !== '2' || !!value;
  //   // }),
  // });

  const step3ValidationSchema = Yup.object().shape({
    currentDesignation: Yup.string().notRequired(),
    // yearsOfExperience: Yup.number()
    //   .typeError("Years of experience must be a number") // Ensures input is a number
    //   .min(0, "Years of experience cannot be negative") // Prevents negative values
    //   .max(50, "Years of experience cannot be more than 50 years")
    //   .required("Years of experience is Required"),
    yearsOfExperience: Yup.number().notRequired(),
    specialization: Yup.string().required("Specialization is Required"),
  });

  const step4ValidationSchema = Yup.object().shape({
    aadharNumber: Yup.string()
      .transform((value) => (value === '' ? undefined : value)) // Treat empty string as undefined
      .matches(/^\d{12}$/, 'Aadhar Number must be 12 digits')
      .required("Aadhar Number is Required"), // Field is optional
    panNumber: Yup.string()
      .transform((value) => (value === '' ? undefined : value)) // Treat empty string as undefined
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
      .required("PAN Number is Required"), // Field is optional
  });


  const step5ValidationSchema = Yup.object().shape({
    accountName: Yup.string().required("Account Name is Required"),
    accountNumber: Yup.string().required("Account Number is Required"),
    bankName: Yup.string().required("Bank Name is Required"),
    branchName: Yup.string().required("Branch Name is Required"),
    ifscCode: Yup.string().required("IFSC Code is Required"),
  });

  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    setCurrentStep((prev) => prev + 1);
  };
  const handlePrevious = () => setCurrentStep((prev) => prev - 1);


  const resolver = yupResolver(
    currentStep === 1
      ? step1ValidationSchema(externalRecruiter)
      : currentStep === 2
        ? step3ValidationSchema
        : currentStep === 3
          ? step4ValidationSchema
          : currentStep === 4
            ? step5ValidationSchema
            : Yup.object() // Default to no validation
  );


  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    trigger,
    setValue
  } = useForm({
    mode: 'onChange',
    resolver,
    defaultValues: {
      name: "",
      address: "",
      state: "",
      contactNumber: "",
      email: "",
      city: "",
      pincode: "",
      rewardType: "",
      rewardsRs: "",
      rewardsPercent: "",
      gender: "",
      currentDesignation: "",
      yearsOfExperience: '',
      accountName: '',
      accountNumber: '',
      bankName: "",
      branchName: "",
      ifscCode: '',
      resumeFile: [],
      companyProfileFile: [],
      aadhaarcardFile: [],
      pancardFile: [],
      bankCancelledChequeFile: [],
      isExternalRecruiter: "",
      alternateNumber: "",
      alternateEmail: ""
    }
  })

  const useLocations = useLocation()
  // const { recruiterIdAdmin } = useLocations?.state || 0

  const { data: ViewRecruiterDetailsById, refetch } = useViewRecruiterDetailsByIdForAdminQuery({ recruiterId: recruiterIdAdmin })
  const [UpdateRecruiter] = useUpdateRecruiterMutation()

  const { Snackbar } = useContext(SnackbarContext)
  const [companyName, setCompanyName] = useState("")
  const [alternateNumber, setAlternateNumber] = useState("")
  const [alternateEmail, setAlternateEmail] = useState("")
  const [recruiterId, setRecruiterId] = useState("")
  const navigate = useNavigate()
  const theme = useTheme()
  const isSmallcreen = useMediaQuery(theme.breakpoints.down('md'))
  const [profileLink, setProfileLink] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [filePath, setFilePath] = useState(null)
  const [fileExtension, setFileExtension] = useState("")
  const [isFile, setIsFile] = useState(false)
  const [resumeFiles, setResumeFiles] = useState([])
  const [companyFiles, setCompanyFiles] = useState([])
  const [aadhaarFiles, setAadhaarFiles] = useState([])
  const [panFiles, setPanFiles] = useState([])
  const [bankFiles, setBankFiles] = useState([])

  const [companyPath, setCompanyPath] = useState(null);
  const [aadhaarPath, setAadhaarPath] = useState(null);
  const [panPath, setPanPath] = useState(null);
  const [bankPath, setBankPath] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [gender, setGender] = useState("");
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (ViewRecruiterDetailsById) {
      const defaultValues = {
        name: ViewRecruiterDetailsById?.response?.data[0]?.name,
        address: ViewRecruiterDetailsById?.response?.data[0]?.street,
        state: ViewRecruiterDetailsById?.response?.data[0]?.state,
        contactNumber: ViewRecruiterDetailsById?.response?.data[0]?.contactNumber,
        email: ViewRecruiterDetailsById?.response?.data[0]?.email,
        companyName: ViewRecruiterDetailsById?.response?.data[0]?.companyName,
        city: ViewRecruiterDetailsById?.response?.data[0]?.city,
        pincode: ViewRecruiterDetailsById?.response?.data[0]?.pincode,
        alternateNumber: ViewRecruiterDetailsById?.response?.data[0]?.alternateContactNumber,
        alternateEmail: ViewRecruiterDetailsById?.response?.data[0]?.alternateEmail,
        recruiterId: ViewRecruiterDetailsById?.response?.data[0]?.recruiterId,
        currentDesignation: ViewRecruiterDetailsById?.response?.data[0]?.currentDesignation,
        yearsOfExperience: ViewRecruiterDetailsById?.response?.data[0]?.yearsOfExperience,
        specialization: ViewRecruiterDetailsById?.response?.data[0]?.specification,
        linkedinProfile: ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile,
        aadharNumber: ViewRecruiterDetailsById?.response?.data[0]?.aadhaarNumber,
        panNumber: ViewRecruiterDetailsById?.response?.data[0]?.panNumber,
        accountName: ViewRecruiterDetailsById?.response?.data[0]?.recruiterAccountName,
        accountNumber: ViewRecruiterDetailsById?.response?.data[0]?.accountNumber,
        bankName: ViewRecruiterDetailsById?.response?.data[0]?.bankName,
        branchName: ViewRecruiterDetailsById?.response?.data[0]?.branch,
        ifscCode: ViewRecruiterDetailsById?.response?.data[0]?.ifscCode,
        resumeFile: ViewRecruiterDetailsById?.response?.data[0]?.resumeFile,
        companyProfileFile: ViewRecruiterDetailsById?.response?.data[0]?.companyProfileFile,
        aadhaarcardFile: ViewRecruiterDetailsById?.response?.data[0]?.aadhaarcardFile,
        pancardFile: ViewRecruiterDetailsById?.response?.data[0]?.pancardFile,
        bankCancelledChequeFile: ViewRecruiterDetailsById?.response?.data[0]?.bankCancelledChequeFile,
        dateOfBirth: (ViewRecruiterDetailsById?.response?.data[0]?.dob),
        gender: ViewRecruiterDetailsById?.response?.data[0]?.gender,
        rewardType: ViewRecruiterDetailsById?.response?.data[0]?.rewardType === null
          ? ''
          : ViewRecruiterDetailsById?.response?.data[0]?.rewardType === 'FC'
            ? 1
            : 2,
        rewardsRs: ViewRecruiterDetailsById?.response?.data[0]?.rewardAmount,
        rewardsPercent: ViewRecruiterDetailsById?.response?.data[0]?.rewardPct,
        isExternalRecruiter: ViewRecruiterDetailsById?.response?.data[0]?.isExternalRecruiter === null ? ""
          : ViewRecruiterDetailsById?.response?.data[0]?.isExternalRecruiter === 'Y' ? 1 : 2
      }
      reset({
        ...defaultValues
      })

      setCompanyName(defaultValues?.companyName)
      setAlternateNumber(defaultValues?.alternateNumber)
      setAlternateEmail(defaultValues?.alternateEmail)
      setRecruiterId(defaultValues?.recruiterId)
      setProfileLink(defaultValues?.linkedinProfile)

      setAccountName(defaultValues?.accountName)
      setAccountNumber(defaultValues?.accountNumber)
      setBankName(defaultValues?.bankName)
      setBranchName(defaultValues?.branchName)
      setIfscCode(defaultValues?.ifscCode)

      setDateOfBirth(dayjs(defaultValues?.dob))
      setGender(defaultValues?.gender)

      const filePath = defaultValues?.resumeFile
      const extension = filePath?.substring(filePath?.lastIndexOf('.') + 1)?.toLowerCase()
      setFilePath(filePath)
      setFileExtension(extension)

      const companyPath = defaultValues?.companyProfileFile
      const companyExtension = companyPath?.substring(companyPath?.lastIndexOf('.') + 1)?.toLowerCase()
      setCompanyPath(companyPath)
      setFileExtension(companyExtension)

      const aadhaarPath = defaultValues?.aadhaarcardFile
      const aadhaarExtension = aadhaarPath?.substring(aadhaarPath?.lastIndexOf('.') + 1)?.toLowerCase()
      setAadhaarPath(aadhaarPath)
      setFileExtension(aadhaarExtension)

      const panPath = defaultValues?.pancardFile
      const panExtension = panPath?.substring(panPath?.lastIndexOf('.') + 1)?.toLowerCase()
      setPanPath(panPath)
      setFileExtension(panExtension)

      const bankPath = defaultValues?.bankCancelledChequeFile
      const bankExtension = bankPath?.substring(bankPath?.lastIndexOf('.') + 1)?.toLowerCase()
      setBankPath(bankPath)
      setFileExtension(bankExtension)
    }
  }, [ViewRecruiterDetailsById])

  const handleDateOfBirth = (value) => {
    setDateOfBirth(value)
  }

  const handleGenderChange = (e) => {
    const value = e.target.value
    setGender(value)
  }

  const handleProfileLink = (e) => {
    const value = e.target.value
    setProfileLink(value)
  }

  const handleAccountName = (e) => {
    const value = e.target.value
    setAccountName(value)
  }

  const handleAccountNumber = (e) => {
    const value = e.target.value
    setAccountNumber(value)
  }

  const handleBankName = (e) => {
    const value = e.target.value
    setBankName(value)
  }

  const handleBranchName = (e) => {
    const value = e.target.value
    setBranchName(value)
  }

  const handleIfscCode = (e) => {
    const value = e.target.value
    setIfscCode(value)
  }

  const handleCompanyName = (e) => {
    const value = e.target.value
    setCompanyName(value)
  }

  const handleAlternateNumber = (e) => {
    const value = e.target.value
    setAlternateNumber(value)
  }

  const handleAlternateEmail = (e) => {
    const value = e.target.value
    setAlternateEmail(value)
  }

  useEffect(() => {
    if (
      resumeFiles.length > 0 ||
      companyFiles.length > 0 ||
      aadhaarFiles.length > 0 ||
      panFiles.length > 0 ||
      bankFiles.length > 0
    ) {
      setIsFile(true);
    } else {
      setIsFile(false);
    }
  }, [resumeFiles, companyFiles, aadhaarFiles, panFiles, bankFiles]);


  const handleFileDrop = (e, setFiles) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };


  const handleFileChange = (e, setFiles) => {
    const newFiles = Array.from(e.target.files); // Get uploaded files
    setFiles((prevFiles) => [...prevFiles, ...newFiles]); // Update state
  };


  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const type = watch("rewardType")

  useEffect(() => {
    if (type === 1) {
      setIsCost(true)
    } else {
      setIsCost(false)
    }
  }, [watch, type])


  const handleCheckboxChange = (e) => {
    setAgreementChecked(e.target.checked);
    if (e.target.checked) {
      setError(false); // Reset error when checked
    }
  };

  const onSubmit = async (data) => {

    // if (!agreementChecked) {
    //   setError(true);
    //   return;
    // }

    if (
      (!resumeFiles?.length && filePath === null && companyPath===null && !companyFiles?.length) ||
      (!aadhaarFiles?.length && aadhaarPath === null) ||
      (!bankFiles?.length && bankPath === null) ||
      (!panFiles?.length && panPath === null)
    ) {
      // Snackbar("Please upload all required documents (Resume, Aadhaar, Bank Cheque, PAN Card)", "error");
      return;
    }


    try {
      // Prepare the payload data
      const payload = {
        address: data?.address,
        alternateEmail: alternateEmail || "",
        alternatePhone: alternateNumber || "",
        city: data?.city,
        companyName: companyName || "",
        contactNumber: data?.contactNumber || "",
        email: data?.email || "",
        id: recruiterId,
        name: data?.name,
        pincode: data?.pincode,
        state: data?.state,
        currentDesignation: data?.currentDesignation || "",
        yearsOfExperience: +data?.yearsOfExperience || 0,
        specification: data?.specialization || "",
        linkedinProfile: profileLink,
        aadhaarNumber: data?.aadharNumber || "",
        panNumber: data?.panNumber || "",
        recruiterAccountName: data?.accountName || "",
        accountNumber: data?.accountNumber || "",
        bankName: data?.bankName || "",
        branch: data?.branchName || "",
        ifscCode: data?.ifscCode || "",
        dob: data?.dateOfBirth ? dayjs(data?.dateOfBirth).format('DD-MM-YYYY') : null,
        gender: data?.gender,
        rewardType: isCost ? "FC" : "FP",
        rewardPct: +data?.rewardsPercent || 0,
        rewardAmount: +data?.rewardsRs || 0,
        isDocsVerify: "Y",
        isExternalRecruiter: data?.isExternalRecruiter === 1 ? 'Y' : 'N'
      };

      // Create FormData instance to append files and data
      const formData = new FormData();

      // Append files conditionally
      if (resumeFiles?.length > 0) {
        const lastResumeIndex = resumeFiles?.length - 1;
        formData.append('resumeFile', resumeFiles[lastResumeIndex]);
      }
      if (companyFiles?.length > 0) {
        const lastCompanyIndex = companyFiles?.length - 1;
        formData.append('companyProfileFile', companyFiles[lastCompanyIndex]);
      }
      if (aadhaarFiles?.length > 0) {
        const lastAadhaarIndex = aadhaarFiles?.length - 1;
        formData.append('aadhaarcardFile', aadhaarFiles[lastAadhaarIndex]);
      }
      if (panFiles?.length > 0) {
        const lastPanIndex = panFiles?.length - 1;
        formData.append('pancardFile', panFiles[lastPanIndex]);
      }
      if (bankFiles?.length > 0) {
        const lastBankIndex = bankFiles.length - 1;
        formData.append('bankCancelledChequeFile', bankFiles[lastBankIndex]);
      }

      // Append the payload data
      formData.append('data', JSON.stringify(payload));

      // Get the token for Authorization
      const token = localStorage.getItem('token');

      // Send the request using fetch
      const response = await fetch(`${window.REACT_APP_BASE_URL}UpdateRecruiter`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response?.ok) {
        const errorData = await response.json();
        if (errorData?.data?.error_message) {
          Snackbar(errorData?.data?.error_message, "error");
        } else {
          Snackbar("The recruiter details updated successfully", "success");
          navigate('/recruiter-details');
        }
      } else {
        Snackbar("Failed to update recruiter details", "error");
      }
    } catch (err) {
      Snackbar('Network error', 'error');
    }
  };

  const steps = ["Basic Details", "Career Details", "Aadhar/PAN", "Bank Details", "Finish"];



  const handleResumeDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = filePath
    // const firstSlash = filePath?.indexOf('/')
    // const secondSlashIndex = filePath?.indexOf('/', firstSlash + 1)
    const path = filePath

    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else if (extension === "pdf") {
      const unwantedPart = '/www/dev-or.g-axis.in/html';
      const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    }
    else {
      Snackbar("Unsupported file type.", 'error');
    }
  };

  const handleCompanyDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = companyPath
    // const firstSlash = companyPath?.indexOf('/')
    // const secondSlashIndex = companyPath?.indexOf('/', firstSlash + 1)
    const path = companyPath

    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else if (extension === "pdf") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    }
    else {
      Snackbar("Unsupported file type.", 'error');
    }
  };

  const handleAadhaarDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = aadhaarPath
    // const firstSlash = aadhaarPath?.indexOf('/')
    // const secondSlashIndex = aadhaarPath?.indexOf('/', firstSlash + 1)
    const path = aadhaarPath

    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else if (extension === "pdf") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    }
    else {
      Snackbar("Unsupported file type.", 'error');
    }
  };

  const handlePANDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = panPath
    // const firstSlash = panPath?.indexOf('/')
    // const secondSlashIndex = panPath?.indexOf('/', firstSlash + 1)
    const path = panPath

    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else if (extension === "pdf") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    }
    else {
      Snackbar("Unsupported file type.", 'error');
    }
  };

  const handleBankDownload = () => {
    // Extract the file extension (docx or pdf)
    // const fileExtension = filePath.split('.').pop().toLowerCase();
    const extension = fileExtension;
    const name = bankPath
    // const firstSlash = bankPath?.indexOf('/')
    // const secondSlashIndex = bankPath?.indexOf('/', firstSlash + 1)
    const path = bankPath

    // Handle the download for DOCX files
    if (extension === "docx" || extension === "doc") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = name; // Optional: Custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    else if (extension === "pdf") {
      // const unwantedPart = '/www/dev-or.g-axis.in/html';
      // const cleanPath = path.replace(unwantedPart, '');
      const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${path}`;
      window.open(url, "_blank");
    }
    else {
      Snackbar("Unsupported file type.", 'error');
    }
  };

  const rewardTypes = [
    {
      id: 1,
      label: "Fixed Amount"
    },
    {
      id: 2,
      label: "Fixed Percentage"
    }
  ]

  const genderOptions = [
    {
      id: 'Male',
      label: "Male"
    },
    {
      id: 'Female',
      label: "Female"
    },
    {
      id: 'Transgender',
      label: "Transgender"
    }
  ]

  const externalOptions = [
    {
      id: 1,
      label: "Yes"
    },
    {
      id: 2,
      label: "No"
    }
  ]

  return (
    <Box className='container'>
      <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px' }} onClick={() => navigate('/recruiter-details')}>
        <ArrowBackIcon sx={{ fontSize: '17px' }} />
        <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
      </Grid2>

      <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {/* Circle for step */}
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: index + 1 <= currentStep ? "#7F56D9" : "#D5D7DA",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {index + 1}
              </Box>
              {/* Step label */}
              <Typography
                sx={{
                  position: "absolute",
                  top: "35px",
                  fontSize: "12px",
                  color: index + 1 <= currentStep ? "#6941C6" : "#B0B0B0",
                }}
              >
                {step}
              </Typography>
              {/* Connecting lines */}
              {index < steps.length - 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "60%", // Start the line from the center of the step
                    transform: "translateX(12px)", // Offset to align with the next step
                    width: "100px", // Fixed width for the connecting line
                    height: "2px",
                    backgroundColor: index + 1 < currentStep ? "#6941C6" : "#B0B0B0",
                    zIndex: 0,
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>

      <Grid2 item sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography className="title" sx={{ marginLeft: '10%', marginTop: "10px" }}>
          {currentStep === 1 && ""}
          {/* {currentStep === 2 && "Career Details"}
                    {currentStep === 3 && "Aadhar/PAN"}
                    {currentStep === 4 && "Bank Details"} */}
        </Typography>
        {currentStep === 1 &&
          <Typography sx={{ marginTop: '10px', fontWeight: 'bold', fontSize: '17.5px', marginRight: '10%' }}>Recruiter Id: {recruiterId}</Typography>}
      </Grid2>
      {currentStep === 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "10px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>
            <form>

              <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Grid2 item container rowGap={2} sx={{ justifyContent: 'space-between', display: 'flex', width: '100%', flexDirection: isSmallcreen && 'column' }}>
                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Name <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"name"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter name"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.name ? errors?.name?.message : ""}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Email <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"email"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter Email"
                          InputProps={{ readOnly: true }}
                          onChange={(e) => {
                            field.onChange(e);
                            trigger('alternateEmail');
                          }}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.email ? errors?.email?.message : ""}
                        />
                      )}
                    />
                  </Grid2>
                </Grid2>

                <Grid2 item sx={{ width: '100%', marginTop: '20px' }}>
                  <InputLabel className="inputlabels">Street/Building <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"address"}
                    render={({ field }) => (
                      <textarea
                        {...field}
                        className="jobPostingTextAreas"
                        placeholder="Enter Street/Building"
                        style={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          },
                          width: '100%',
                          minHeight: "80px",
                          resize: 'none'
                        }}
                        helperText={errors?.address ? errors?.address?.message : ""}
                      />
                    )}
                  />
                  {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.address ? errors.address?.message : ""}</span>}
                </Grid2>

                <Grid2 item container rowGap={2} sx={{ marginTop: '15px', width: '100%', justifyContent: 'space-between', flexDirection: isSmallcreen && 'column' }}>
                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">State <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"state"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter State"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.state ? errors?.state?.message : ""}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Contact Number <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"contactNumber"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          className="textfields"
                          placeholder="Enter Contact Number"
                          onChange={(e) => {
                            field.onChange(e); // update field value
                            trigger('alternateNumber'); // manually trigger validation of alternate number
                          }}
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.contactNumber ? errors?.contactNumber?.message : ""}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Company Name </InputLabel>
                    <TextField
                      className="textfields"
                      placeholder="Enter Company Name"
                      value={companyName}
                      onChange={handleCompanyName}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">City <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"city"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter City"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.city ? errors?.city?.message : ""}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Pincode <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name="pincode"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="text"
                          className="textfields"
                          placeholder="Enter Pincode"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.pincode ? errors?.pincode?.message : ""}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Alternate Number</InputLabel>
                    <Controller
                      control={control}
                      name="alternateNumber"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter Alternate Number"
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.alternateNumber?.message}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Alternate Email</InputLabel>
                    <Controller
                      control={control}
                      name="alternateEmail"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          placeholder="Enter Alternate Email"
                          sx={{
                            "& .MuiFormHelperText-root": {
                              color: 'red',
                              marginLeft: '-1px'
                            }
                          }}
                          helperText={errors?.alternateEmail?.message}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="inputlabels">Date of Birth <span style={{ color: 'red' }}>*</span></InputLabel>
                    {/* <MuiDatePicker
                      value={dateOfBirth || null}
                      onChange={handleDateOfBirth}
                    /> */}
                    <Controller
                      name="dateOfBirth"
                      control={control}
                      render={({ field }) => (
                        <MuiDatePicker
                          {...field}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          slotProps={{ textField: { error: !!errors.dateOfBirth, helperText: errors.dateOfBirth?.message } }}
                        />
                      )}
                    />
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="addJobPostingInput">Gender <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"gender"}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          className="dropdown"
                          displayEmpty
                          placeholder="Select Gender"
                          valueKey='id'
                          labelKey='label'
                          options={genderOptions || []}
                        />
                      )}
                    />
                    {errors?.gender?.message && (
                      <div style={{ color: 'red', fontSize: '0.8rem' }}>
                        {errors?.gender?.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                    <InputLabel className="addJobPostingInput">Business Associate<span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"isExternalRecruiter"}
                      render={({ field }) => (
                        <Dropdown
                          {...field}
                          className="dropdown"
                          displayEmpty
                          placeholder="Select External Type"
                          valueKey="id"
                          labelKey="label"
                          options={externalOptions || []}
                        />
                      )}
                    />
                    {errors?.isExternalRecruiter?.message && (
                      <div style={{ color: 'red', fontSize: '0.7rem' }}>
                        {errors?.isExternalRecruiter?.message}
                      </div>
                    )}

                  </Grid2>

                </Grid2>
              </Grid2>

            </form>
          </Box>
        </Box>
      )}

      {/* {currentStep === 2 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>
            <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                <InputLabel className="addJobPostingInput">Rewards Type <span style={{ color: 'red' }}>*</span></InputLabel>
                <Controller
                  control={control}
                  name={"rewardType"}
                  render={({ field }) => (
                    <Dropdown
                      {...field}
                      className="dropdown"
                      displayEmpty
                      placeholder="Select Reward Type"
                      valueKey="id"
                      labelKey="label"
                      options={rewardTypes || []}
                    />
                  )}
                />
                {errors?.rewardType?.message && (
                  <div style={{ color: 'red', fontSize: '0.7rem' }}>
                    {errors?.rewardType?.message}
                  </div>
                )}

              </Grid2>

              <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                {isCost ? (
                  <>
                    <InputLabel className="addJobPostingInput">Rewards (Rs) <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"rewardsRs"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          size="small"
                          type="number"
                          sx={{
                            width: "100%", // Ensures it fits the modal width
                            "& .MuiInputBase-input.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                          placeholder="Enter Rewards (Rs)"
                          onWheel={(e) => e.target.blur()}
                          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                          disabled={!type}
                        />
                      )}
                    />
                    {errors?.rewardsRs?.message && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>{errors?.rewardsRs?.message}</div>
                    )}
                  </>
                ) : (
                  <>
                    <InputLabel className="addJobPostingInput">Rewards (%) <span style={{ color: 'red' }}>*</span></InputLabel>
                    <Controller
                      control={control}
                      name={"rewardsPercent"}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className="textfields"
                          size="small"
                          type="number"
                          sx={{
                            width: "100%", // Ensures it fits the modal width
                            "& .MuiInputBase-input.Mui-disabled": {
                              cursor: "not-allowed",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                          placeholder="Enter Rewards (%)"
                          onWheel={(e) => e.target.blur()}
                          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                          disabled={!type}
                        />
                      )}
                    />
                    {errors?.rewardsPercent?.message && (
                      <div style={{ color: "red", fontSize: "0.7rem" }}>{errors?.rewardsPercent?.message}</div>
                    )}
                  </>
                )}
              </Grid2>
            </Grid2>
          </Box>
        </Box>
      )} */}

      {currentStep === 2 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>

            <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid2 item container rowGap={2} sx={{ justifyContent: 'space-between', display: 'flex', width: '100%', flexDirection: isSmallcreen && 'column' }}>
                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Current Designation </InputLabel>
                  <Controller
                    control={control}
                    name={"currentDesignation"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Designation"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.currentDesignation ? errors?.currentDesignation?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Years of experience </InputLabel>
                  <Controller
                    control={control}
                    name={"yearsOfExperience"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Years Of Experience"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.yearsOfExperience ? errors?.yearsOfExperience?.message : ""}
                      />
                    )}
                  />
                </Grid2>
              </Grid2>

              <Grid2 item container rowGap={2} sx={{ marginTop: '15px', justifyContent: 'space-between', display: 'flex', width: '100%', flexDirection: isSmallcreen && 'column' }}>
                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Specialization <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"specialization"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Specialization"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.specialization ? errors?.specialization?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">LinkedIn</InputLabel>
                  <TextField
                    className="textfields"
                    placeholder="Enter LinkedIn Link"
                    value={profileLink}
                    onChange={handleProfileLink}
                  />
                </Grid2>
              </Grid2>
            </Grid2>

          </Box>
        </Box>
      )}

      {currentStep === 3 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>

            <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid2 item container rowGap={2} sx={{ justifyContent: 'space-between', display: 'flex', width: '100%', flexDirection: isSmallcreen && 'column' }}>
                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Aadhar Number <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"aadharNumber"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Aadhar Number"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.aadharNumber ? errors?.aadharNumber?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">PAN Number <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"panNumber"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter PAN Number"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.panNumber ? errors?.panNumber?.message : ""}
                      />
                    )}
                  />
                </Grid2>
              </Grid2>
            </Grid2>

          </Box>
        </Box>
      )}

      {currentStep === 4 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>

            <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Grid2 item container rowGap={2} sx={{ justifyContent: 'space-between', display: 'flex', width: '100%', flexDirection: isSmallcreen && 'column' }}>
                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Account Name <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"accountName"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Account Name"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.accountName ? errors?.accountName?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Account Number <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"accountNumber"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Account Number"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.accountNumber ? errors?.accountNumber?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Bank Name <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"bankName"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Bank Name"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.bankName ? errors?.bankName?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">Branch Name <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"branchName"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter Branch Name"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.branchName ? errors?.branchName?.message : ""}
                      />
                    )}
                  />
                </Grid2>

                <Grid2 item sx={{ alignItems: 'center', width: !isSmallcreen ? '40%' : '100%' }}>
                  <InputLabel className="inputlabels">IFSC Code <span style={{ color: 'red' }}>*</span></InputLabel>
                  <Controller
                    control={control}
                    name={"ifscCode"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="textfields"
                        placeholder="Enter IFSC Code"
                        sx={{
                          "& .MuiFormHelperText-root": {
                            color: 'red',
                            marginLeft: '-1px'
                          }
                        }}
                        helperText={errors?.ifscCode ? errors?.ifscCode?.message : ""}
                      />
                    )}
                  />
                </Grid2>

              </Grid2>
            </Grid2>

          </Box>
        </Box>
      )}

      {currentStep === 5 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
          <Box sx={{ border: '1px solid #D5D7DA', width: '80%', padding: '32px' }}>
            <FileUpload
              title={<span>Upload Your Resume<span style={{ color: 'red' }}>*</span> </span>}
              uniqueId="resumeUpload"
              required={false}
              acceptedFormats=".pdf, .doc, .docx"
              files={resumeFiles}
              filePath={filePath}
              handleDrop={(e) => handleFileDrop(e, setResumeFiles)}
              handleDragOver={handleDragOver}
              handleFileChange={(e) => handleFileChange(e, setResumeFiles)}
              handleDownload={handleResumeDownload}
            />

            {(resumeFiles?.length === 0 && filePath === null && companyFiles?.length === 0 && companyPath === null) && (
              <Typography color="red" style={{ fontSize: '0.8rem' }}>Resume file is required</Typography>
            )}

            <Box mt={2}>
              <FileUpload
                title={<span>Company Profile<span style={{ color: 'red' }}>*</span> </span>}
                uniqueId="companyUpload"
                required={false}
                acceptedFormats=".pdf, .doc, .docx"
                files={companyFiles}
                filePath={companyPath}
                handleDrop={(e) => handleFileDrop(e, setCompanyFiles)}
                handleDragOver={handleDragOver}
                handleFileChange={(e) => handleFileChange(e, setCompanyFiles)}
                handleDownload={handleCompanyDownload}
              />

              {(resumeFiles?.length === 0 && filePath === null && companyFiles?.length === 0 && companyPath === null) && (
                <Typography color="red" style={{ fontSize: '0.8rem' }}>Company Profile is required</Typography>
              )}
            </Box>

            <Box mt={2}>
              <FileUpload
                title={<span>Aadhaar Card <span style={{ color: 'red' }}>*</span> </span>}
                uniqueId="aadhaarUpload"
                required={false}
                acceptedFormats=".pdf, .doc, .docx"
                files={aadhaarFiles}
                filePath={aadhaarPath}
                handleDrop={(e) => handleFileDrop(e, setAadhaarFiles)}
                handleDragOver={handleDragOver}
                handleFileChange={(e) => handleFileChange(e, setAadhaarFiles)}
                handleDownload={handleAadhaarDownload}
              />
              {(aadhaarFiles?.length === 0 && aadhaarPath === null) && (
                <Typography color="red" style={{ fontSize: '0.8rem' }}>Aadhaar card is required</Typography>
              )}
            </Box>

            <Box mt={2}>
              <FileUpload
                title={<span>PAN Card<span style={{ color: 'red' }}>*</span> </span>}
                uniqueId="panUpload"
                required={false}
                acceptedFormats=".pdf, .doc, .docx"
                files={panFiles}
                filePath={panPath}
                handleDrop={(e) => handleFileDrop(e, setPanFiles)}
                handleDragOver={handleDragOver}
                handleFileChange={(e) => handleFileChange(e, setPanFiles)}
                handleDownload={handlePANDownload}
              />
              {(panFiles?.length === 0 && panPath === null) && (
                <Typography color="red" style={{ fontSize: '0.8rem' }}>PAN card is required</Typography>
              )}

            </Box>

            <Box mt={2}>
              <FileUpload
                title={<span>Bank Cancelled Cheque<span style={{ color: 'red' }}>*</span> </span>}
                uniqueId="bankUpload"
                required={false}
                acceptedFormats=".pdf, .doc, .docx"
                files={bankFiles}
                filePath={bankPath}
                handleDrop={(e) => handleFileDrop(e, setBankFiles)}
                handleDragOver={handleDragOver}
                handleFileChange={(e) => handleFileChange(e, setBankFiles)}
                handleDownload={handleBankDownload}
              />
              {(bankFiles?.length === 0 && bankPath === null) && (
                <Typography color="red" style={{ fontSize: '0.8rem' }}>Bank cancelled cheque is required</Typography>
              )}
            </Box>
          </Box>
        </Box>


      )}

      {/* {currentStep === 5 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "20px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreementChecked}
                onChange={handleCheckboxChange}
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 20 },
                  '&.Mui-checked': { color: '#7F56D9' },
                  padding: 1
                }}
              />
            }
            label="I confirm that I have reviewed and verified all recruitment documents and details."
          />

          {error && (
            <FormHelperText sx={{ color: "red", fontSize: '0.8rem', textAlign: 'center' }}>
              Please agree to continue
            </FormHelperText>
          )}
        </Box>
      )} */}


      {/* Buttons Section */}
      <Grid2 item sx={{ display: "flex", gap: "20px", justifyContent: "flex-end", marginTop: "30px", }}>
        {currentStep > 1 && (
          <MUICancelButton
            title="Previous"
            onClick={handlePrevious}
          />
        )}
        {currentStep < 5 ? (
          <MUIButton
            title="Next"
            onClick={handleSubmit(handleNext)}
            sx={{ backgroundColor: "#7F56D9", width: "130px" }}
          />
        ) : (
          <>
            <MUICancelButton title='Cancel' onClick={() => navigate('/recruiter-details')} />
            <MUIButton title='Finish' onClick={handleSubmit(onSubmit)} sx={{ backgroundColor: '#7F56D9', width: '130px' }} />
          </>
        )}
      </Grid2>
    </Box>
  )
}

export default RecruiterProfileEdit;